//  Action Imports
import { fetchError, fetchStart, fetchSuccess } from "../Common";

/**
 *  Type Imports
 */
import {
  GET_ADMIN_MANAGEMENT_DATA,
  EDIT_ADMIN_INFORMATION_START,
  EDIT_ADMIN_INFORMATION_FINISH,
  OPEN_ADMIN_DELETE_DIALOG,
  CLOSE_ADMIN_DELETE_DIALOG,
} from "shared/constants/ActionTypes";

/**
 *  Service Imports
 */
import ApiService from "@crema/services/ApiService";
import { adminApi } from "shared/constants/AppConst";

/**
 *  Admin Actions
 */
export const onGetAdminsManagementData = () => {
  return async (dispatch) => {
    try {
      dispatch(fetchStart());

      let data = await ApiService.get(adminApi.getAllWithPermissions);
      const result = {
        data: data.data,
        editing: false,
        pagination: {
          start: 0,
          limit: 10,
          page: 0,
          count: data.total, //total
        },
        editingAdmin: null,
        deleting: false,
        deletingAdmin: null,
        sending: false,
        selectedAdmin: null,
      };
      dispatch({
        type: GET_ADMIN_MANAGEMENT_DATA,
        payload: result,
      });

      dispatch(fetchSuccess());
    } catch (e) {
      dispatch(fetchError(e.message));
    }
  };
};

export const onEditAdminInformationStart = (admin) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: EDIT_ADMIN_INFORMATION_START,
        payload: admin,
      });

      return admin;
    } catch (e) {
      dispatch(fetchError(e.message));
    }
  };
};

export const onEditAdminInformationFinish = () => {
  return (dispatch) => {
    dispatch({
      type: EDIT_ADMIN_INFORMATION_FINISH,
    });
  };
};

export const openAdminDeleteDialog = (payload) => {
  return (dispatch) => {
    dispatch({
      type: OPEN_ADMIN_DELETE_DIALOG,
      payload,
    });
  };
};

export const closeAdminDeleteDialog = () => {
  return (dispatch) => {
    dispatch({
      type: CLOSE_ADMIN_DELETE_DIALOG,
    });
  };
};
export const setAdminCurrentTablePage = (page, limit) => {
  return async (dispatch) => {
    try {
      dispatch(fetchStart());

      const start = page * limit;

      let data = await ApiService.get(
        adminApi.getWithPermissions(start, limit)
      );

      const result = {
        data: data.data,
        editing: false,
        pagination: {
          start,
          page,
          limit,
          count: data.total, //total
        },
        editingUser: null,
        deleting: false,
        deletingUser: null,
        sending: false,
        selectedUser: null,
      };

      dispatch({
        type: GET_ADMIN_MANAGEMENT_DATA,
        payload: result,
      });
      dispatch(fetchSuccess());
    } catch (e) {
      dispatch(fetchError(e.message));
    }
  };
};
export const setAdminRowsPerPage = (limit) => {
  return async (dispatch) => {
    try {
      dispatch(fetchStart());

      let data = await ApiService.get(adminApi.getWithPermissions(0, limit));

      const result = {
        data: data.data,
        editing: false,
        pagination: {
          start: 0,
          page: 0,
          limit: limit,
          count: data.total, //total
        },
        editingAdmin: null,
        deleting: false,
        deletingAdmin: null,
        sending: false,
        selectedAdmin: null,
      };

      dispatch({
        type: GET_ADMIN_MANAGEMENT_DATA,
        payload: result,
      });
      dispatch(fetchSuccess());
    } catch (e) {
      dispatch(fetchError(e.message));
    }
  };
};
